/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Modal } from "react-bootstrap";
import BaseCom from "../../components/BaseCom";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import L from "../../components/Lang";
import FormInput from "../../components/FormInput";
import { qreq } from "../../shared/qrequest";

class SignUpModal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    async componentDidMount() {
        await this.getSettings();
    }

    componentDidUpdate(prevProps) {
        if(this.props.show !== prevProps.show) {
            this.setState({ info: {}, success: null });
        }
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    submit = async (e) => {
        e?.preventDefault();
        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/signup', this.state.info);
            if (j.errorCode === 0)
                this.setState({ success: true });
            else
                this.warn(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header>
                <Modal.Title>
                    <L>Sign Up</L>
                    <p style={{ fontWeight: 'normal' }}><L>Already have an account?</L> <span role="button" className="text-primary" onClick={this.props.onLogin}>Login</span></p>
                </Modal.Title>
            </Modal.Header>
            {this.state.success ? <><Modal.Body>
                <p><L>An email has been sent to</L> <strong>{this.state.info.email}</strong> <L>for confirmation, please check your email for further instructions.</L></p>
            </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-success w-100" onClick={this.props.onHide}><L>Close</L></button>
                </Modal.Footer>
            </>
                : <form onSubmit={this.submit}>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6">
                                <FormInput model={this.state.info} name="firstName" label="First Name" type="text" onChange={this.change} placeholder="John" />
                            </div>
                            <div className="col-md-6">
                                <FormInput model={this.state.info} name="lastName" label="Last Name" type="text" onChange={this.change} placeholder="Doe" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <FormInput model={this.state.info} name="businessName" label="Business Name" type="text" onChange={this.change} placeholder="Acme" />
                            </div>
                            <div className="col-md-6">
                                <FormInput model={this.state.info} name="phone" label="Business Phone" type="text" onChange={this.change} placeholder="000-000-0000" />
                            </div>
                        </div>
                        <FormInput model={this.state.info} name="email" label="Business email" type="email" onChange={this.change} placeholder="info@example.net" />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="submit" className="btn btn-success w-100" disabled={this.state.submitting}><L>Sign Up</L></button>
                    </Modal.Footer>
                </form>}
        </Modal>
    }
}

export default withParamsAndNavigate(SignUpModal);